export const types = {
  // auth
  authCheckingFinish: "[auth] Finish checking login state",
  authStartLogin: "[auth] Start login",
  authLogin: "[auth] Login",
  authStartRegister: "[auth] Start Register",
  authStartStartTokenRenew: "[auth] Start token renew",
  authLogout: "[auth] Logout",

  // courses
  coursesStartFetch: "[courses] Start fetch",
  coursesFetch: "[courses] Fetch",
  coursesFetchSuccess: "[courses] Fetch success",
  coursesFetchError: "[courses] Fetch error",

  coursesStartCreate: "[courses] Start create",
  coursesCreate: "[courses] Create",
  coursesCreateSuccess: "[courses] Create success",
  coursesCreateError: "[courses] Create error",

  coursesStartUpdate: "[courses] Start update",
  coursesUpdate: "[courses] Update",
  coursesUpdateSuccess: "[courses] Update success",
  coursesUpdateError: "[courses] Update error",

  coursesStartDelete: "[courses] Start delete",
  coursesDelete: "[courses] Delete",
  coursesDeleteSuccess: "[courses] Delete success",
  coursesDeleteError: "[courses] Delete error",

  //categories
  categoriesStartCreate: "[categories] Start create",
  categoriesCreate: "[categories] Create",
  categoriesCreateError: "[categories] Create error",

  categoriesStartFetch: "[categories] Start fetch",
  categoriesFetch: "[categories] Fetch",
  categoriesFetchError: "[categories] Fetch Error",

  categoriesStartDelete: "[categories] Start delete",
  categoriesDelete: "[categories] Delete",
  categoriesDeleteError: "[categories] Delete error",

  // courseSections
  sectionStartCreate: "[section] Start create",
  sectionCreate: "[section] Create",
  sectionCreateError: "[section] Create error",

  sectionStartFetch: "[section] Start fetch",
  sectionFetch: "[section] Fetch",
  sectionFetchError: "[section] Fetch error",

  sectionStartUpdate: "[section] Start update",
  sectionUpdate: "[section] Update",
  sectionUpdateError: "[section] Update error",

  sectionStartDelete: "[section] Start delete",
  sectionDelete: "[section] Delete",
  sectionDeleteError: "[section] Delete error",

  // courseLessons
  lessonStartCreate: "[lesson] Start create",
  lessonCreate: "[lesson] Create",
  lessonCreateError: "[lesson] Create error",

  lessonStartFetch: "[lesson] Start fetch",
  lessonFetch: "[lesson] Fetch",
  lessonFetchError: "[lesson] Fetch error",

  lessonStartUpdate: "[lesson] Start update",
  lessonUpdate: "[lesson] Update",
  lessonUpdateError: "[lesson] Update error",

  lessonStartDelete: "[lesson] Start delete",
  lessonDelete: "[lesson] Delete",
  lessonDeleteError: "[lesson] Delete error",

  // courseQuiz
  quizStartCreate: "[quiz] Start create",
  quizCreate: "[quiz] Create",
  quizCreateError: "[quiz] Create error",

  quizStartFetch: "[quiz] Start fetch",
  quizFetch: "[quiz] Fetch",
  quizFetchError: "[quiz] Fetch error",

  quizStartUpdate: "[quiz] Start update",
  quizUpdate: "[quiz] Update",
  quizUpdateError: "[quiz] Update error",

  quizStartDelete: "[quiz] Start delete",
  quizDelete: "[quiz] Delete",
  quizDeleteError: "[quiz] Delete error",

  //quizQuestions
  questionStartCreate: "[question] Start create",
  questionCreate: "[question] Create",
  questionCreateError: "[question] Create error",

  questionStartFetch: "[question] Start fetch",
  questionFetch: "[question] Fetch",
  questionFetchError: "[question] Fetch error",

  questionStartUpdate: "[question] Start update",
  questionUpdate: "[question] Update",
  questionUpdateError: "[question] Update error",

  questionStartDelete: "[question] Start delete",
  questionDelete: "[question] Delete",
  questionDeleteError: "[question] Delete error",

  //Payments
  paymentStartFetch: "[payment] Start fetch",
  paymentFetch: "[payment] Fetch",
  paymentFetchError: "[payment] Fetch error",

  paymentStartApproved: "[payment] Start update",
  paymentApproved: "[payment] Update",
  paymentApprovedError: "[payment] Update error",

  paymentStartRejected: "[payment] Start delete",
  paymentRejected: "[payment] Delete",
  paymentRejectedError: "[payment] Delete error",
};
